import React from 'react'

// Gavin's own button artwork (emailed 11 Oct), in place of the MUI icons that
// stood in for it. Each is a silhouette on transparency, drawn as a
// mask so it takes the button's `color` — white at rest, the skin's green
// while lit — exactly as the MUI icons did through `currentColor`.
//
// Follow and view redrawn 16 Oct: the follow arrow read as a second play
// button, so it is a compass again, and the eye is Gavin's new one.
//
// 22 Oct: the compass redrawn fatter ("Follow-Button-2.png") — the thin ring
// read too light beside the rest of the bar. Same shape, same 24px box.
//
// 3 Nov: the eye redrawn again ("view-eye-2.png"), wider — 126 × 90, so 29
// across at the same 21 high.
//
// Sizes are the artwork's own proportions, scaled to sit at the weight of the
// 24px MUI icons still beside them in the bar.
const GLYPHS = {
  threeSixty: { image: '/img/button-360.png', width: 30, height: 21 },
  view: { image: '/img/view-eye-2.png', width: 29, height: 21 },
  follow: { image: '/img/button-follow.png', width: 24, height: 24 },
} as const

export type PlayerGlyphName = keyof typeof GLYPHS

export interface PlayerGlyphProps {
  name: PlayerGlyphName
  /** Multiplies the glyph's size, e.g. for a menu row's smaller icon. */
  scale?: number
  style?: React.CSSProperties
}

export default function PlayerGlyph({ name, scale = 1, style }: PlayerGlyphProps) {
  const { image, width, height } = GLYPHS[name]
  return (
    <span
      aria-hidden="true"
      style={{
        display: 'inline-block',
        flexShrink: 0,
        width: width * scale,
        height: height * scale,
        backgroundColor: 'currentColor',
        WebkitMaskImage: `url(${image})`,
        maskImage: `url(${image})`,
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        ...style,
      }}
    />
  )
}
